import { SCondition, RequestQueryBuilder } from '@nestjsx/crud-request';
import { map } from 'rxjs/operators';
import { ManyResponse } from '../../../responses/many.response';
import { Injectable } from '@angular/core';
import { TorchAPIConfiguration } from '../../../config/api.configuration';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Burly } from 'kb-burly';
import { SortDirection } from '@angular/material/sort';
import { AesRequestSpanTimeTable } from '../models/aes-requests/aes-request-span-time-table.model';
import { AesTeamNames } from '@backend/modules/@crt/models/aes-requests/aes-team-names.model';
import { reject } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class TorchAesRequestsService {

  constructor(protected config: TorchAPIConfiguration, private httpClient: HttpClient) {
  }

  public queryRequests(pageSize: number = 15,
                       currentPage: number = 0,
                       sortDirection: 'ASC' | 'DESC' | '' = 'DESC',
                       sortBy: string = 'id',
                       filters: SCondition | null): Observable<ManyResponse<AesRequestSpanTimeTable>> {
    const qb = RequestQueryBuilder.create();

    qb.setPage(currentPage + 1).setLimit(pageSize);

    if (!!sortDirection && sortDirection != null) {
      qb.sortBy({field: sortBy, order: sortDirection});
    }

    if (!!filters) {
      qb.search(filters);
    }

    let finalURL;
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/aes-requests')
      .appendRawQueryString(qb.query(false));

    finalURL = endpoint.get;

    return this.httpClient.get<ManyResponse<AesRequestSpanTimeTable>>(finalURL);
  }

  public getTeamsByTeam(teams) {
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/aes-requests')
      .addSegment('/team')
      .addQuery('filters', 'team||$in||' + teams)
      .get;

    return this.httpClient.get<AesTeamNames[]>(endpoint)
  }

  public getTeamsByUsername(user) {
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/aes-requests')
      .addSegment('/team')
      .addQuery('filters', 'username||$eq||' + user)
      .get;

    return this.httpClient.get<AesTeamNames[]>(endpoint)
  }


  public getAesTeams(contains): Observable<string[]> {
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/aes-requests')
      .addSegment('/aesTeams')
      .addQuery('contains', contains)
      .get;

    return this.httpClient.get<[{ TEAM: string }]>(endpoint).pipe(
      map(response => response.map(v => v.TEAM))
    );
  }

  public getEventTypes(contains): Observable<string[]> {
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/aes-requests')
      .addSegment('/eventTypes')
      .addQuery('contains', contains)
      .get;

    return this.httpClient.get<[{ EVENT_TYPE: string }]>(endpoint).pipe(
      map(response => response.map(v => v.EVENT_TYPE))
    );
  }

  public getResponsibleUsers(contains): Observable<string[]> {
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/aes-requests')
      .addSegment('/responsibleUsers')
      .addQuery('contains', contains)
      .get;

    return this.httpClient.get<[{ RESPONSIBLE_USERNAME: string }]>(endpoint).pipe(
      map(response => response.map(v => v.RESPONSIBLE_USERNAME))
    );
  }

  public getRequestNumberList(): Observable<string[]> {
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/aes-requests')
      .addSegment('/requestNumbers')
      .get;

    return this.httpClient.get<[{ REQUEST_NBR: string }]>(endpoint).pipe(
      map(response => response.map(v => v.REQUEST_NBR))
    );

  }

  public addRequest(request: AesRequestSpanTimeTable) {
    const endpointURL = Burly(this.config.rootUrl)
      .addSegment('/aes-requests')
      .get;

    return new Promise((resolve, reject) => {
      this.httpClient.post(endpointURL, request)
        .subscribe((response) => {
          resolve(response);
        }, reject);
    });


  }

  public saveRequest(request: AesRequestSpanTimeTable) {
    const endpointURL = Burly(this.config.rootUrl)
      .addSegment('/aes-requests')
      .addSegment('/' + request.id)
      .get;

    return new Promise((resolve, reject) => {
      this.httpClient.patch(endpointURL, request)
        .subscribe((response) => {
          resolve(response);
        }, reject);
    });


  }

  public deleteRequest(request: AesRequestSpanTimeTable) {
    const endpointURL = Burly(this.config.rootUrl)
      .addSegment('/aes-requests')
      .addSegment('/' + request.id)
      .get;

    return new Promise((resolve, reject) => {
      this.httpClient.delete(endpointURL)
        .subscribe((response) => {
          resolve(response);
        }, reject);
    });
  }

  public exportToExcel(aesRequests: AesRequestSpanTimeTable[]) {
    return new Observable(subscriber => {
      let endpoint = Burly(this.config.rootUrl)
        .addSegment('/aes-requests')
        .addSegment('/export')
        .get;

      const httpOptions: { headers; observe; responseType; } = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        observe: 'response',
        responseType: 'blob'
      };

      const body = {
        aesRequests: aesRequests
      }
      this.httpClient.post(endpoint, body, httpOptions).subscribe((response) => {
        subscriber.next((response as unknown as HttpResponse<any>).body);
        subscriber.complete();
      });
    });

  }
}
